import { render, staticRenderFns } from "./ImageZoomOnHover.vue?vue&type=template&id=08d8d6b1&"
import script from "./ImageZoomOnHover.js?vue&type=script&lang=js&"
export * from "./ImageZoomOnHover.js?vue&type=script&lang=js&"
import style0 from "./ImageZoomOnHover.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports